import { takeEvery, call, all, fork } from "redux-saga/effects";
import {
  CHANGE_LANGUAGE,
} from "./../ApplicationLanguage/action";

import AsyncStorage from "@react-native-async-storage/async-storage";

export function* onLanguageSaga(action) {
    yield call(AsyncStorage.setItem, "language", action.payload.code);
}

export function* languageSaga() {
  yield takeEvery(CHANGE_LANGUAGE, onLanguageSaga);
}

export function* allLanguageSaga() {
  yield all([
    fork(languageSaga),
  ]);
}
